import Powers from './Powers';
import Ids from './Ids';
import Plans from './Plans';
import './main.css';
import UserAppContext from '../../hook/UserAppContext';

const MainContent = () => {

      const {user} = UserAppContext()

      if(!user.user.seller) return

      const {plans, ids, powers} = user.user.seller

      return (
            <div className="main_content">
                  <Plans plans={plans} />

                  <Ids ids={ids} />

                  <Powers powers={powers} />
            </div>
      )
}

export default MainContent;